import PropTypes from 'prop-types';
import React from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../baseContainers/BaseListContainer';
import ActionLink from '../components/ActionLink';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import TrailerModel from '../model/TrailerModel';
import TrailerService from '../services/TrailerService';
import TrailerDialog from './TrailerDialog';
import CriteriaRadioButtonComponent from '../components/criteria/CriteriaRadioButtonComponent';
import {baseReportCsv, baseReportPdf, baseXLSXReport} from '../report/ReportUtils';

class TrailerList extends BaseListContainer {
    constructor(props) {
        super(props, new TrailerService());
        this.state = {
            list: [],
            selectedList: [],
            selectAll: false,
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            statusOptions: [],
            roleTypeOptions: [],
            typeOptions: [],
        };
        this.handleOpenNewDialog = this.handleOpenNewDialog.bind(this);
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.ownTemplate = this.ownTemplate.bind(this);
    }
    getDataKey() {
        return 'sapId';
    }

    getListTitle() {
        return 'trailer.listTitle';
    }
    updateSearchCriteria(criteria) {
        return {
            number: criteria.number,
            type: criteria.type,
            own: criteria.own,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            number: '',
            type: undefined,
            own: undefined,
            firstResult: 0,
            maxResults: 10,
            sortField: 'number',
            sortAsc: true,
        };
    }

    initializeFromBackend() {
        const {t} = this.props;
        this.enumService
            .getEnumList('EcTrailerType', t)
            .then((typeOptions) =>
                this.setState({
                    typeOptions: [].concat(typeOptions).reverse(),
                })
            )
            .catch(() => {
                this.showErrorMessage(t('error.statusListError'));
            });
    }

    getCriteriaName() {
        return 'trailer-list-sc';
    }

    getContainerListName() {
        return 'trailer-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderCriteria() {
        const {t} = this.props;
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='registrationNumber-sc'
                    name='registrationNumber'
                    label={t('trailer.registrationNumber')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.registrationNumber}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    validators='not_required|alpha_num'
                    keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż0-9]*$/i}
                />
                <CriteriaRadioButtonComponent
                    id='type-sc'
                    name='type'
                    colClass='col-xl-4 col-lg-6 col-md-6 col-sm-6'
                    viewMode='EDIT'
                    options={this.state.typeOptions}
                    value={this.state.criteria.type}
                    valueLabel='label'
                    labelOnRight
                    valueKey='enumValue'
                    itemColClass={'col-xl-6 col-lg-6 col-md-12 col-sm-12'}
                    onChange={this.handleChangeSc}
                    label={t('trailer.type')}
                    validator={this.validator}
                    validators=''
                />
                <CriteriaRadioButtonComponent
                    id='own-sc'
                    name='own'
                    colClass='col-xl-4 col-lg-6 col-md-6 col-sm-6'
                    viewMode='EDIT'
                    options={[
                        {name: 'true', label: 'własny'},
                        {name: 'false', label: 'wynajęty'},
                    ]}
                    value={this.state.criteria.own}
                    valueLabel='label'
                    labelOnRight
                    valueKey='name'
                    itemColClass={'col-xl-6 col-lg-6 col-md-12 col-sm-12'}
                    onChange={this.handleChangeSc}
                    label={t('trailer.own')}
                    validator={this.validator}
                    validators=''
                />
            </div>
        );
    }

    prepareColumns() {
        const {t} = this.props;
        return [
            {
                key: 'registrationNumber',
                field: 'registrationNumber',
                header: t('trailer.registrationNumber'),
                sortable: true,
            },
            {
                key: 'type',
                field: 'type',
                header: t(`trailer.type`),
                body: this.enumTemplate.bind(this, 'EcTrailerType', 'type'),
                sortable: true,
                sortField: 'type',
            },
            {
                key: 'own',
                field: 'own',
                header: t(`vehicle.own`),
                body: this.ownTemplate.bind(this, 'own'),
                sortable: true,
                sortField: 'own',
            },

            {
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }
    ownTemplate(field, rowData) {
        const {t} = this.props;
        if (rowData && rowData[field] !== null && rowData[field] !== undefined && rowData[field] === true) {
            return t('trailer.own-true');
        } else return t('trailer.own-false');
    }
    actionTemplate(rowData) {
        const {t} = this.props;
        return (
            <ActionLink
                label={t('details.editButton')}
                handleClick={this.handleOpenDialog.bind(this, rowData)}
                variant='blue'
                className='edit-blue-link'
                key={'view-button'}
            />
        );
    }
    prepareHeaderItems() {
        const {t} = this.props;
        return this.isUserInAnyRole('ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL')
            ? [
                  {type: 'LABEL', className: 'float-left'},
                  {
                      label: t('trailer.addButton'),
                      onClick: this.handleOpenNewDialog,
                      type: 'BUTTON',
                      className: 'float-right',
                      variant: 'white',
                      iconSvg: 'ico_white_plus',
                      iconSide: 'left',
                  },

                  {
                      type: 'BUTTON',
                      className: 'right-side',
                      variant: 'white',
                      disabled: !this.state.selectedList || this.state.selectedList.length < 1,
                      customRenderFunction: this.renderPrintButton,
                  },
              ]
            : [];
    }

    generateReport(format) {
        const {t, lazy} = this.props;
       // const list = this.state.selectedList;
        const list = (this.hasFilter() && this.state.selectAll && lazy === false )? this.processData() : this.state.selectedList;
        if (format === 'csv') {
            const fields = [
                {value: 'registrationNumber', label: t('trailer.registrationNumber')},
                {value: this.enumTemplate.bind(this, 'EcTrailerType', 'type'), label: t(`trailer.type`)},
                {value: this.ownTemplate.bind(this, 'own'), label: t(`vehicle.own`)},
            ];
            return Promise.resolve(baseReportCsv(list, fields));
        }
        const columns = [
            {header: t('trailer.registrationNumber'), field: 'registrationNumber'},
            {header: t(`trailer.type`), field: 'type', getColFunction: this.enumTemplate.bind(this, 'EcTrailerType', 'type')},
            {header: t(`vehicle.own`), field: 'own', getColFunction: this.ownTemplate.bind(this, 'own')},
        ];
        if (format === 'pdf') {
            const blob = baseReportPdf({list, title: t(this.getListTitle()), columns, landscape: true}, this.props.t);
            return Promise.resolve(blob);
        } else if (format === 'xlsx' || format === 'ods') {
            const request = {};
            request.columns = columns;
            request.list = list;
            request.sheetName = t(this.getListTitle()).replaceAll(/[*?\][\\/]/g, ' ,');
            return Promise.resolve(baseXLSXReport(request, format));
        }
    }
    handleOpenDialog(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: rowData, dialogViewMode: 'EDIT'});
    }
    handleOpenNewDialog(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: new TrailerModel(), dialogViewMode: 'NEW'});
    }
    handleCloseDialog(id, callback) {
        // if (e) {
        //     e.preventDefault()
        // }
        this.setState({dialogVisibile: false, element: undefined}, () => {
            if (callback) {
                callback();
            }
        });
    }
    render() {
        const {t} = this.props;
        return (
            <div className='container-fluid driver-list-container'>
                {this.state.dialogVisibile ? (
                    <TrailerDialog
                        key={`trailer-dialog-${this.state.element?.number}`}
                        element={this.state.element}
                        onHide={(e) => this.handleCloseDialog(e)}
                        visible={this.state.dialogVisibile}
                        viewMode={this.state.dialogViewMode}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, () => {
                                this.readMessage();
                                this.refreshTable();
                            })
                        }
                        typeOptions={this.state.typeOptions}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                    />
                ) : null}
                <BreadcrumbsItem to='/driver-list'>{t('trailer.listName')}</BreadcrumbsItem>
                {this.renderView()}
            </div>
        );
    }
}

TrailerList.defaultProps = {
    detailUrl: '/#/invoice/details',
    newUrl: '/#/invoice/create',
    lazy: false,
    disableSelection: false,
    selectionMode: 'multiple',
};

TrailerList.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withTranslation()(TrailerList);
